var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 33,
    viewBox: "0 0 48 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.3125C0 15.3115 0.811493 14.5 1.8125 14.5H45.3125C46.3135 14.5 47.125 15.3115 47.125 16.3125C47.125 17.3135 46.3135 18.125 45.3125 18.125H1.8125C0.811493 18.125 0 17.3135 0 16.3125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5309 0.530863C30.2387 -0.176954 31.3864 -0.176954 32.0942 0.530863L46.5942 15.0309C47.3021 15.7388 47.3021 16.8862 46.5942 17.5941L32.0942 32.0941C31.3864 32.8019 30.2387 32.8019 29.5309 32.0941C28.823 31.3862 28.823 30.2388 29.5309 29.5309L42.7493 16.3125L29.5309 3.09413C28.823 2.38631 28.823 1.23868 29.5309 0.530863Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.62cd3a0e6ed80329f3dda2419946396f.svg";
export { ForwardRef as ReactComponent };